import React, { useState } from "react";
import { Modal } from "antd";
import { Icon } from "@iconify/react";
import { Select, Space } from "antd";

const AdddocpatternModal = ({ adddocpatternmodal, setadddocpatternmodal }) => {
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleOk = () => {
    setadddocpatternmodal(false);
  };
  const handleCancel = () => {
    setadddocpatternmodal(false);
  };
  return (
    <>
      <Modal
        open={adddocpatternmodal}
        onOk={handleOk}
        onCancel={handleCancel}
        className="editdoctype-modal"
        centered={true}
        width="39%"
      >
        <div className="modal-content mt-5">
          <h2 className="fw-bold text-medium-black text-center">
            Add / Edit Document Type
          </h2>
          <form>
            <div className="template-div v-center h-center flex-column mt-5">
              <div className="edit-profile-main d-flex flex-column gap-2">
                <div className="edit-profile-inner d-flex flex-column gap-3">
                  <h5>Select Document Type</h5>
                  <Space wrap>
                    <Select
                      defaultValue="Group 1"
                      style={{ width: 317 }}
                      options={[
                        { value: "Group 1", label: "Group 1" },
                        { value: "Group 2", label: "Group 2" },
                        { value: "Group 3", label: "Group 3" },
                      ]}
                    />
                  </Space>
                </div>
                <div className="check-me-div d-flex gap-2 mt-2">
                  <input
                    type="checkbox"
                    id="customCheckboxSelectAll"
                    style={{ display: "none" }}
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label
                    htmlFor="customCheckboxSelectAll"
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: isChecked ? "#435AB8 " : "transparent",
                      }}
                    >
                      {isChecked && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                  <label className="elarge "> Public group</label>
                </div>
                <div className=" d-flex justify-content-end gap-2">
                  <button className="modal-dark-btn">Add</button>
                </div>
              </div>
              <div
                className="hrLine my-4 w-100  text-light-gray "
                style={{ height: "2px" }}
              ></div>
              <div className="edit-profile-main d-flex flex-column gap-2">
                <div className="edit-profile-inner d-flex flex-column gap-3">
                  <h5>Select Group</h5>
                  <Space wrap>
                    <Select
                      defaultValue="Group 1"
                      style={{ width: 317 }}
                      options={[
                        { value: "Group 1", label: "Group 1" },
                        { value: "Group 2", label: "Group 2" },
                        { value: "Group 3", label: "Group 3" },
                      ]}
                    />
                  </Space>
                </div>
              </div>
              <div className="edit-profile-main d-flex flex-column gap-2 mt-4">
                <div className="edit-profile-inner d-flex flex-column gap-3">
                  <h5>Select Pattern</h5>
                  <Space wrap>
                    <Select
                      defaultValue="Group 1"
                      style={{ width: 317 }}
                      options={[
                        { value: "Group 1", label: "Group 1" },
                        { value: "Group 2", label: "Group 2" },
                        { value: "Group 3", label: "Group 3" },
                      ]}
                    />
                  </Space>
                </div>
              </div>
            </div>
          </form>
          <div className="modal-bottom-btns h-center gap-2">
            <button className="modal-dark-btn" onClick={handleCancel}>
              Close
            </button>
            <button className="modal-dark-btn" onClick={handleOk}>
              Save
            </button>
            <button className="modal-trans-btn">Reset</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AdddocpatternModal;
